module.exports = __webpack_public_path__ + "static/media/huoyanshan3.356a9ee3.webp";